var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4.24002C11.0883 4.0789 11.7931 3.99836 12.5 4.00003C19.5 4.00003 23.5 12 23.5 12C22.893 13.1356 22.1691 14.2048 21.34 15.19M14.62 14.12C14.3454 14.4148 14.0141 14.6512 13.6462 14.8151C13.2782 14.9791 12.8809 15.0673 12.4781 15.0744C12.0753 15.0815 11.6752 15.0074 11.3016 14.8565C10.9281 14.7056 10.5887 14.4811 10.3038 14.1962C10.019 13.9113 9.79439 13.572 9.64351 13.1984C9.49262 12.8249 9.41853 12.4247 9.42563 12.0219C9.43274 11.6191 9.52091 11.2219 9.68488 10.8539C9.84884 10.4859 10.0853 10.1547 10.38 9.88003M18.44 17.94C16.7306 19.243 14.6491 19.9649 12.5 20C5.5 20 1.5 12 1.5 12C2.74389 9.68192 4.46914 7.65663 6.56 6.06003L18.44 17.94Z",
    stroke: "#EF452F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1L23.5 23",
    stroke: "#EF452F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.02ad64f76434573fd600edb36b288c79.svg";
export { ForwardRef as ReactComponent };